import { render, staticRenderFns } from "./CreateNewProject.vue?vue&type=template&id=5fe55756&scoped=true"
import script from "./CreateNewProject.vue?vue&type=script&lang=js"
export * from "./CreateNewProject.vue?vue&type=script&lang=js"
import style0 from "./CreateNewProject.vue?vue&type=style&index=0&id=5fe55756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe55756",
  null
  
)

export default component.exports